/**
 * Computes the X-Request-Sig header value for OTP-protected endpoints.
 *
 * Algorithm mirrors RequestSignatureValidator.cs:
 *   bucket  = floor(unixSeconds / 60)
 *   message = "${bucket}${identifier.trim()}"
 *   sig     = HMAC-SHA256(key, message) as lowercase hex
 *
 * The backend accepts the current bucket and the previous one (~2 min window).
 */
export async function computeRequestSig(
  identifier: string
): Promise<string | null> {
  const key = process.env.REACT_APP_OTP_HMAC_SIGNING_KEY;
  if (!key) return null;

  const bucket = Math.floor(Date.now() / 1000 / 60);
  const message = `${bucket}${identifier.trim()}`;

  const enc = new TextEncoder();
  const cryptoKey = await globalThis.crypto.subtle.importKey(
    "raw",
    enc.encode(key),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );

  const rawSig = await globalThis.crypto.subtle.sign(
    "HMAC",
    cryptoKey,
    enc.encode(message)
  );

  return Array.from(new Uint8Array(rawSig))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
